import {Button, CheckBox, FileUploader, Popup, SelectBox, TextBox} from "devextreme-react";
import React, {useEffect, useRef, useState} from "react";

import {Modal,Form} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import {i18n} from "../../core";
import {Conf} from "../../core/config/Conf";

export default function NewUserModal(props){
	const [data,setData]=useState(null)
	const fileUploaderRef = useRef();
	useEffect(()=>{
		if(props.data) {
			setData({...props.data, icon: props?.data?.image})
		}else{
			setData(null)
		}
	},[props.data])
	const onHandleImage=(e)=> {

		if(e && e.length>0){
			const reader = new FileReader();
			reader.onload = function(){
				setData({...data,icon:reader.result,fileChange:true});
			};
			reader.readAsDataURL(e[0]);
		}

	}
	return  data !==null && <Modal show={true} onHide={()=>props.onClose()}>
		<Modal.Header closeButton>
			<Modal.Title>{i18n.t('იუზერის დამატება')}</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<Form>

				<Form.Group className="mb-3" controlId="form2">
					<Form.Label>{i18n.t("სახელი")}</Form.Label>
					<Form.Control  type={"text"} value={data.firstName} onChange={e=>setData({...data,firstName:e.target.value})} />
				</Form.Group>
				<Form.Group className="mb-3" controlId="form2">
					<Form.Label>{i18n.t("გვარი")}</Form.Label>
					<Form.Control  type={"text"} value={data.lastName} onChange={e=>setData({...data,lastName:e.target.value})} />
				</Form.Group>
				<Form.Group className="mb-3" controlId="form2">
					<Form.Label>{i18n.t("პირადი ნომერი")}</Form.Label>
					<Form.Control  type={"text"} value={data.idNumber} onChange={e=>setData({...data,idNumber:e.target.value})} />
				</Form.Group>
				<Form.Group className="mb-3" controlId="form2">
					<Form.Label>{i18n.t("ტელეფონის ნომერი")}</Form.Label>
					<Form.Control  type={"text"} value={data.phone} onChange={e=>setData({...data,phone:e.target.value})} />
				</Form.Group>
				<Form.Group controlId="formFile" className="mb-3">
					<Form.Label>{i18n.t("აირჩიეთ ფოტო")}</Form.Label>
					<Form.Control type="file" ref={fileUploaderRef} onChange={e=>onHandleImage(e.target.files)}/>
				</Form.Group>

				<Form.Group controlId="formFile" className="mb-3">
					{
						data.icon !==null && data.icon !=="" && data.icon  !==undefined  && <div style={{position:'relative',width:"150px"}}>
							<div style={{
								position:"absolute",
								right:"10px",
								top:"10px",
								cursor:'pointer'
							}}
								 onClick={()=>{
									 fileUploaderRef.current.value=""
									 setData({...data,icon:"",image:'',fileChange:true});
								 }}
							>
								<FontAwesomeIcon icon={faTimes} color={"red"} size={"2x"}  />
							</div>
							<img src={data.icon && data?.fileChange ?  data.icon:Conf.fileUri+data.icon} width={"150px"} height={"auto"}  alt={"image"}/>
						</div>
					}
				</Form.Group>
				<div className="dx-field">
					<div className="dx-field-value" style={{width:"30px"}}>
						<CheckBox value={data?.sendPassword} onValueChanged={e=>{
							setData({...data,sendPassword:e.value})
						}} />
					</div>
					<div className="dx-field-label" style={{width:"100%"}} >&nbsp;&nbsp;&nbsp; {i18n.t("პაროლის სმს-ის საშუალებით გაგზავნა")}</div>

				</div>
			</Form>
		</Modal.Body>
		<Modal.Footer>
			<Button variant="secondary" onClick={()=>props.onClose()}>
				{i18n.t("დახურვა")}
			</Button>
			<Button variant="primary" onClick={()=>props.onSave(data)}>
				{i18n.t("შენახვა")}
			</Button>
		</Modal.Footer>
	</Modal>


}


